import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-seq-aside-blank",
  "use": "icon-seq-aside-blank-usage",
  "viewBox": "0 0 299 40",
  "content": "<symbol viewBox=\"0 0 299 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-seq-aside-blank\">\n<rect x=\"49\" y=\"6\" width=\"60\" height=\"10\" rx=\"4\" fill=\"#F4F5F8\" />\n<rect x=\"49\" y=\"26\" width=\"97\" height=\"10\" rx=\"4\" fill=\"#F4F5F8\" />\n<rect x=\"150\" y=\"26\" width=\"97\" height=\"10\" rx=\"4\" fill=\"#F4F5F8\" />\n<rect width=\"40\" height=\"40\" rx=\"8\" fill=\"#F4F5F8\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol